// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1166":"c85d8a11","8877":"6fe494d7","9686":"da5498f9"}[chunkId] + ".chunk.css";
};